import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IRaffleEventSectionProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const RaffleEventSection = styled.div<IRaffleEventSectionProps>`
  background: #fff;
  padding: 0 0 32px;

  ${({ $bgColor, $textColor }) =>
    ($bgColor || $textColor) &&
    css`
      background: ${$bgColor};
    `}

  &.bg-type-black {
    background: #000;
  }

  .visual-wrap {
    position: relative;

    img {
      position: static !important;
    }
  }

  .raffle-event-btn {
    display: flex;
    justify-content: center;
    width: calc(100% - 40px);
    height: 50px;
    margin: 24px auto 20px;
    padding: 0 26px;
    line-height: 130%;
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    background: #000;
    color: #fff;

    ${({ $pointColor, $emphasisTextColor }) =>
      ($pointColor || $emphasisTextColor) &&
      css`
        &.btn {
          background: ${$pointColor};
          color: ${$emphasisTextColor};
        }
      `}
  }

  &.bg-type-black .raffle-event-btn {
    background: #fff;
    color: #000;
  }

  .event-notice {
    padding: 20px 20px 0;

    .notice-wrap {
      .text {
        padding-left: 0;

        &:after {
          display: none;
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('32 0')};

    .event-notice {
      padding: ${mixin.pxToVw('20 20 0')};
    }

    .raffle-event-btn {
      width: calc(100% - ${mixin.pxToVw('40')});
      height: ${mixin.pxToVw('50')};
      margin: ${mixin.pxToVw('24 auto 20')};
      padding: ${mixin.pxToVw('0')};
      font-size: ${mixin.pxToVw('15')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 0 0 40px 0;

    &.has-text .visual-wrap:after {
      background: rgba(0, 0, 0, 0.1);
    }

    .event-notice {
      width: var(--pc-width);
      margin: 0 auto;
      padding: 30px 0 0;
    }

    .raffle-event-btn {
      max-width: 520px;
      height: 60px;
      margin: 48px auto 0;
      font-size: 20px;
      font-weight: 500;
    }
  }
`;
